import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  expirationWrapper: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
    color: theme.palette.black.main,
  },
  expirationSoonColor: {
    fontWeight: 400,
    color: theme.palette.labraV2Errors.main,
  },
  expirePrefixSplit: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    verticalAlign: 'middle',
    color: theme.palette.labraV2Errors.main,
    flexShrink: 0,
  },
  expireSuffixSplit: {
    marginLeft: theme.spacing(0.5),
    verticalAlign: 'middle',
  },
}))
